import { useEffect, useState } from "react";
import { SLOGAN } from "../../lib/site";
import { useSite } from "../../context/SiteContext";

const shouldShow = () => !window.location.pathname.startsWith("/admin");

export const IntroSplash = () => {
  const { settings } = useSite();
  const [phase, setPhase] = useState(() => (shouldShow() ? "in" : "done"));

  useEffect(() => {
    if (phase !== "in") return undefined;
    const t = setTimeout(() => setPhase("out"), 3000);
    return () => clearTimeout(t);
  }, [phase]);

  useEffect(() => {
    if (phase !== "out") return undefined;
    const t = setTimeout(() => setPhase("done"), 750);
    return () => clearTimeout(t);
  }, [phase]);

  if (phase === "done") return null;
  const badge = settings.campaign_active && settings.campaign_badge ? `Tüm Paketlerde ${settings.campaign_badge}` : "";
  return (
    <div
      role="presentation"
      onClick={() => setPhase("out")}
      data-testid="intro-splash"
      className={`fixed inset-0 z-[100] cursor-pointer overflow-hidden bg-forest transition-[opacity,transform] duration-700 ease-[cubic-bezier(0.65,0,0.35,1)] ${phase === "out" ? "pointer-events-none -translate-y-6 opacity-0" : "opacity-100"}`}
    >
      <img
        src="/images/intro-storefront.webp"
        srcSet="/images/intro-storefront-m.webp 828w, /images/intro-storefront.webp 1600w"
        sizes="100vw"
        alt=""
        aria-hidden="true"
        fetchPriority="high"
        className="intro-photo absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(1,27,21,0.72) 0%, rgba(2,44,34,0.62) 45%, rgba(1,27,21,0.82) 100%)" }} />
      <div className="relative flex h-full flex-col items-center justify-center px-6 text-center">
        <div className="intro-logo rounded-[28px] bg-cream/95 p-4 ring-1 ring-gold/50 sm:p-5">
          <img src="/images/lunessa-logo.webp" alt="lunessa-spa-masaj-logo" className="h-28 w-auto sm:h-36" width="120" height="120" />
        </div>
        <div className="mt-8 flex items-center gap-3">
          <span className="intro-line-l block h-px w-16 bg-gradient-to-l from-gold to-transparent sm:w-28" />
          <span className="intro-dot block h-1.5 w-1.5 rotate-45 bg-gold" />
          <span className="intro-line-r block h-px w-16 bg-gradient-to-r from-gold to-transparent sm:w-28" />
        </div>
        <p className="intro-slogan mt-5 text-base font-medium tracking-wide text-gold-light sm:text-lg">{SLOGAN}</p>
        <p className="intro-sub mt-3 whitespace-nowrap text-[10.5px] font-semibold uppercase tracking-[0.1em] text-white/75 sm:text-xs sm:tracking-[0.22em]">
          Online Randevu{badge && <span className="mx-2 text-gold">•</span>}{badge}
        </p>
      </div>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setPhase("out"); }}
        className="absolute bottom-6 right-6 rounded-full px-3 py-1.5 text-xs font-medium tracking-[0.2em] text-white/60 transition-colors hover:text-gold-light"
        data-testid="intro-skip"
      >
        GEÇ
      </button>
    </div>
  );
};
